export default "__VITE_ASSET__vZq_C9ay__"